module.exports = __webpack_public_path__ + "static/images/bottom-image.89f7bd9b0b4fddc5c65bf75cc36b16cc.png";